import React, { useState, useEffect } from 'react';
import { useAuth } from '../lib/AuthContext';
import supabase from '../lib/supabase';

const S = {
  page: { minHeight: 'calc(100vh - 56px)', background: '#0f1115', padding: '32px 16px', display: 'flex', justifyContent: 'center' },
  wrap: { width: '100%', maxWidth: '560px' },
  title: { fontSize: '22px', fontWeight: 800, color: '#fff', marginBottom: '24px' },
  card: { background: '#1a1d24', borderRadius: '12px', padding: '24px', border: '1px solid #2a2d35', marginBottom: '16px' },
  cardTitle: { fontSize: '13px', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '16px' },
  label: { fontSize: '11px', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '6px', display: 'block' },
  input: { width: '100%', background: '#0f1115', border: '1px solid #2a2d35', borderRadius: '8px', color: '#fff', fontSize: '14px', padding: '10px 12px', outline: 'none', marginBottom: '12px', fontFamily: 'monospace' },
  btn: { width: '100%', background: '#00e701', color: '#000', fontWeight: 700, fontSize: '14px', border: 'none', borderRadius: '8px', height: '44px', cursor: 'pointer', transition: 'filter 0.15s', marginBottom: '8px' },
  btnOutline: { width: '100%', background: 'transparent', color: '#00e701', fontWeight: 700, fontSize: '14px', border: '1px solid #00e701', borderRadius: '8px', height: '44px', cursor: 'pointer', transition: 'filter 0.15s', marginBottom: '8px' },
  info: { background: 'rgba(0,231,1,0.06)', border: '1px solid rgba(0,231,1,0.2)', borderRadius: '8px', padding: '12px 14px', fontSize: '13px', color: '#9ca3af', lineHeight: '1.6', marginBottom: '12px' },
  warning: { background: 'rgba(252,177,15,0.08)', border: '1px solid rgba(252,177,15,0.3)', borderRadius: '8px', padding: '12px 14px', fontSize: '13px', color: '#fcb10f', lineHeight: '1.6', marginBottom: '12px' },
  success: { background: 'rgba(0,231,1,0.1)', border: '1px solid #00e701', borderRadius: '8px', padding: '12px 14px', fontSize: '13px', color: '#00e701', marginBottom: '12px' },
  error: { background: 'rgba(255,32,32,0.1)', border: '1px solid #ff2020', borderRadius: '8px', padding: '12px 14px', fontSize: '13px', color: '#ff6666', marginBottom: '12px' },
  tabWrap: { display: 'flex', gap: '4px', marginBottom: '20px', background: '#0f1115', padding: '4px', borderRadius: '8px' },
  tab: { flex: 1, padding: '10px', borderRadius: '6px', border: 'none', background: 'transparent', color: '#6b7280', fontWeight: 600, fontSize: '13px', cursor: 'pointer', transition: 'background 0.15s, color 0.15s' },
  tabActive: { background: '#1a1d24', color: '#fff' },
  statRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', fontSize: '14px' },
  statLabel: { color: '#6b7280' },
  statVal: { color: '#fff', fontWeight: 600 },
  summary: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#0f1115', borderRadius: '8px', padding: '16px', marginBottom: '16px' },
  summaryLabel: { fontSize: '13px', color: '#6b7280' },
  summaryValue: { fontSize: '18px', fontWeight: 800, color: '#00e701' },
};

export default function Deposit() {
  const { profile, refreshProfile } = useAuth();
  const [tab, setTab] = useState('deposit');
  const [depositAmount, setDepositAmount] = useState('');
  const [depositStatus, setDepositStatus] = useState('');
  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [withdrawStatus, setWithdrawStatus] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [pendingDeposits, setPendingDeposits] = useState([]);
  const [withdrawals, setWithdrawals] = useState([]);

  useEffect(() => {
    if (profile) {
      loadPendingDeposits();
      loadWithdrawals();
    }
  }, [profile]);

  async function loadPendingDeposits() {
    if (!profile) return;
    const { data } = await supabase
      .from('deposits')
      .select('*')
      .eq('user_id', profile.id)
      .eq('status', 'pending')
      .order('created_at', { ascending: false });
    setPendingDeposits(data || []);
  }

  async function loadWithdrawals() {
    if (!profile) return;
    const { data } = await supabase
      .from('withdrawals')
      .select('*')
      .eq('user_id', profile.id)
      .order('created_at', { ascending: false })
      .limit(10);
    setWithdrawals(data || []);
  }

  const depositRobux = parseInt(depositAmount) || 0;
  const depositCredits = depositRobux;

  const handleDepositAmountChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setDepositAmount(value);
  };

  async function handleBuyRobux() {
    if (depositRobux < 7) {
      setError('Minimum deposit is 7 R$');
      return;
    }

    setLoading(true);
    setError('');

    const depositId = `${profile.id}_${Date.now()}`;

    const { error: insertError } = await supabase
      .from('deposits')
      .insert([{
        user_id: profile.id,
        username: profile.username,
        amount: depositCredits,
        robux_amount: depositRobux,
        game_pass_id: 'custom',
        status: 'pending',
        deposit_id: depositId,
      }]);

    if (insertError) {
      setError('Failed to create deposit. Please try again.');
      setLoading(false);
      return;
    }

    await loadPendingDeposits();
    setDepositStatus(`✅ Deposit #${depositId.slice(-6)} created. Complete your R$${depositRobux} purchase in Roblox, then click "Check Purchase" below.`);
    setLoading(false);
  }

  async function checkPurchase() {
    setLoading(true);
    setError('');
    setDepositStatus('');

    try {
      const pending = pendingDeposits[0];
      if (!pending) {
        setError('No pending deposits found.');
        setLoading(false);
        return;
      }

      const response = await fetch('/api/check-purchase', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_DEPOSIT_API_KEY,
        },
        body: JSON.stringify({
          deposit_id: pending.deposit_id,
          user_id: profile.id,
          action: 'verify',
        }),
      });

      const result = await response.json();

      if (result.success) {
        await supabase
          .from('deposits')
          .update({ status: 'completed' })
          .eq('id', pending.id);

        await supabase
          .from('users')
          .update({ balance: Number(profile.balance || 0) + pending.amount })
          .eq('id', profile.id);

        await supabase.from('transactions').insert([{
          user_id: profile.id,
          type: 'deposit',
          amount: pending.amount,
          status: 'completed',
          description: `Robux deposit: ${pending.robux_amount} R$`,
        }]);

        await refreshProfile();
        await loadPendingDeposits();
        setDepositStatus(`✅ Purchase verified! ₿${pending.amount} credited to your balance.`);
      } else {
        setError(result.message || 'Purchase not found. Make sure you completed the purchase.');
      }
    } catch (e) {
      setError('Failed to check purchase. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  async function handleWithdraw() {
    const amount = parseInt(withdrawAmount) || 0;
    if (amount < 5) {
      setError('Minimum withdrawal is ₿5.00');
      return;
    }
    if (amount > Number(profile.balance || 0)) {
      setError('Insufficient balance');
      return;
    }

    setLoading(true);
    setError('');
    setWithdrawStatus('');

    try {
      await supabase
        .from('withdrawals')
        .insert([{
          user_id: profile.id,
          username: profile.username,
          amount: amount,
          status: 'pending',
        }]);

      await supabase
        .from('users')
        .update({ balance: Number(profile.balance || 0) - amount })
        .eq('id', profile.id);

      await supabase.from('transactions').insert([{
        user_id: profile.id,
        type: 'withdrawal',
        amount: amount,
        status: 'pending',
        description: `Robux withdrawal request for ${profile.username}`,
      }]);

        await refreshProfile();
        setWithdrawStatus(`✅ Withdrawal request submitted for ₿${amount}. You will receive R$${Math.floor(amount * 80)} once approved.`);
      setWithdrawAmount('');
    } catch (e) {
      setError('Failed to submit withdrawal. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={S.page}>
      <div style={S.wrap}>
        <div style={S.title}>💰 Deposit / Withdraw</div>

        <div style={S.tabWrap}>
          <button
            style={{ ...S.tab, ...(tab === 'deposit' ? S.tabActive : {}) }}
            onClick={() => setTab('deposit')}
          >
            Deposit Robux
          </button>
          <button
            style={{ ...S.tab, ...(tab === 'withdraw' ? S.tabActive : {}) }}
            onClick={() => setTab('withdraw')}
          >
            Withdraw Robux
          </button>
        </div>

        {tab === 'deposit' && (
          <>
            <div style={S.card}>
              <div style={S.cardTitle}>Deposit Amount</div>

              {error && <div style={S.error}>{error}</div>}
              {depositStatus && <div style={S.success}>{depositStatus}</div>}

              <label style={S.label}>Enter Robux Amount</label>
              <input
                style={S.input}
                type="text"
                inputMode="numeric"
                placeholder="80"
                value={depositAmount}
                onChange={handleDepositAmountChange}
              />

              {depositRobux >= 7 && (
                <div style={S.summary}>
                  <span style={S.summaryLabel}>You'll receive</span>
                  <span style={S.summaryValue}>₿{depositCredits}</span>
                </div>
              )}

              <button
                style={{ ...S.btn, opacity: loading || depositRobux < 7 ? 0.7 : 1 }}
                onClick={handleBuyRobux}
                disabled={loading || depositRobux < 7}
              >
                {loading ? 'Processing...' : depositRobux >= 7 ? `Deposit R$${depositRobux} → ₿${depositCredits}` : 'Minimum: 7 R$'}
              </button>

              {pendingDeposits.length > 0 && (
                <button
                  style={{ ...S.btnOutline, opacity: loading ? 0.7 : 1 }}
                  onClick={checkPurchase}
                  disabled={loading}
                >
                  {loading ? 'Checking...' : 'I Completed Purchase - Check Now'}
                </button>
              )}
            </div>

            <div style={S.card}>
              <div style={S.cardTitle}>How It Works</div>
              <div style={S.info}>
                1. Enter the amount of Robux you want to deposit<br />
                2. Click "Deposit" to open the Roblox purchase page<br />
                3. Complete your purchase in Roblox<br />
                4. Return here and click "Check Purchase"<br />
                5. Your balance will be credited automatically
              </div>
              <div style={S.warning}>
                ⚠️ Rate: 1:1. Deposits may take up to 5 minutes to process.
              </div>
            </div>
          </>
        )}

        {tab === 'withdraw' && (
          <>
            <div style={S.card}>
              <div style={S.cardTitle}>Withdraw to Roblox</div>

              <div style={S.statRow}>
                <span style={S.statLabel}>Your Username</span>
                <span style={S.statVal}>{profile?.username}</span>
              </div>
                <div style={S.statRow}>
                  <span style={S.statLabel}>Available Balance</span>
                  <span style={S.statVal}>₿{Math.floor(Number(profile?.balance || 0))}</span>
                </div>

              <div style={{ height: '16px' }} />

              {error && <div style={S.error}>{error}</div>}
              {withdrawStatus && <div style={S.success}>{withdrawStatus}</div>}

              <label style={S.label}>Withdrawal Amount (₿)</label>
              <input
                style={S.input}
                type="text"
                inputMode="numeric"
                placeholder="5"
                value={withdrawAmount}
                onChange={e => setWithdrawAmount(e.target.value.replace(/[^0-9]/g, ''))}
              />

              {parseInt(withdrawAmount) > 0 && (
                <div style={S.summary}>
                  <span style={S.summaryLabel}>You'll receive</span>
                  <span style={S.summaryValue}>R${Math.floor((parseInt(withdrawAmount) || 0) * 80)}</span>
                </div>
              )}

              <button
                style={{ ...S.btn, opacity: loading ? 0.7 : 1 }}
                onClick={handleWithdraw}
                disabled={loading}
              >
                {loading ? 'Processing...' : 'Request Withdrawal'}
              </button>

              <div style={S.info}>
                Withdrawals are queued and processed manually. You will receive your Robux once approved. This usually takes 24-48 hours.
              </div>
            </div>

            <div style={S.card}>
              <div style={S.cardTitle}>Withdrawal Rules</div>
              <div style={S.info}>
                • Minimum withdrawal: ₿5.00<br />
                • Withdrawals are sent to your linked Roblox account<br />
                • Processing time: 24-48 hours<br />
                • Username must match your account: <strong>{profile?.username}</strong>
              </div>
            </div>

            {withdrawals.length > 0 && (
              <div style={S.card}>
                <div style={S.cardTitle}>Your Withdrawals</div>
                {withdrawals.map(w => (
                  <div key={w.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #2a2d35' }}>
                    <div>
                      <div style={{ fontSize: '14px', color: '#fff', fontWeight: 600 }}>₿{Math.floor(Number(w.amount))}</div>
                      <div style={{ fontSize: '11px', color: '#6b7280' }}>{new Date(w.created_at).toLocaleDateString()}</div>
                    </div>
                    <span style={{
                      display: 'inline-block',
                      borderRadius: '4px',
                      padding: '4px 10px',
                      fontSize: '11px',
                      fontWeight: 700,
                      textTransform: 'uppercase',
                      background: w.status === 'completed' ? 'rgba(0,231,1,0.15)' : w.status === 'cancelled' ? 'rgba(255,68,68,0.15)' : 'rgba(252,177,15,0.15)',
                      color: w.status === 'completed' ? '#00e701' : w.status === 'cancelled' ? '#ff4444' : '#fcb10f',
                    }}>
                      {w.status}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
